<template>
	<div class="user_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('home.my') }}</div>
		</div>
		<div class="top_header">
			<router-link to="/sign" class="set_go"></router-link>
			<div class="user_detail">
				<div class="user_header">
					<img :src="data.user_icon" alt="">
				</div>
				<div class="user_name">
					<div class="user_all">
						<p class="user_nickname">{{ data.name ? data.name : data.mobile }}</p>
					</div>
				</div>
			</div>
			<div class="user_vip">
				<p>{{ $t('user.welcome') }}{{ data.vip_name }}</p>
			</div>
			<div class="user_balance" v-if="eye == 1">
				<div>
					{{ $t('user.totalBalance') }}
					<van-icon name="eye-o" @click="eye = 0" />
				</div>
				<div>
					{{ $t('utils.moneyMark') }}:{{ data.all_money }}
					<span class="eth_inline">ETH:{{ ethDisplay }} </span>
				</div>
			</div>
			<div class="user_balance" v-if="eye == 0">
				<div>
					{{ $t('user.totalBalance') }}
					<van-icon name="closed-eye" @click="eye = 1" />
				</div>
				<div>
					******
					<span class="eth_inline">******</span>
				</div>
			</div>
			<div class="user_money" v-if="eye == 1">
				<div>
					<p>{{ $t('user.uncollectedPrincipal') }}</p>
					<p>+{{ $t('utils.moneyMark') }}{{ data.wait_money }}</p>
				</div>
				<div>
					<p>{{ $t('user.uncollectedInterest') }}</p>
					<p>+{{ $t('utils.moneyMark') }}{{ data.wait_lixi }}</p>
				</div>
				<div>
					<p>{{ $t('user.cumulativeIncome') }}</p>
					<p>+{{ $t('utils.moneyMark') }}{{ data.all_lixi }}</p>
				</div>
			</div>
			<div class="user_money" v-if="eye == 0">
				<div>
					<p>{{ $t('user.uncollectedPrincipal') }}</p>
					<p>******</p>
				</div>
				<div>
					<p>{{ $t('user.uncollectedInterest') }}</p>
					<p>******</p>
				</div>
				<div>
					<p>{{ $t('user.cumulativeIncome') }}</p>
					<p>******</p>
				</div>
			</div>
		</div>
		<div class="kong"></div>
		<div class="user_yw">
			<div @click="$router.push('/order')">
				<img src="../images/user/order.png" alt="" />
				<p>{{ $t('user.myInvestment') }}</p>
			</div>
			<div @click="$router.push('/moneybag')">
				<img src="../images/user/details.png" alt="" />
				<p>{{ $t('user.transactionDetails') }}</p>
			</div>
			<div @click="toKeFu">
				<img src="../images/user/kf.png" alt="" />
				<p>{{ $t('user.onlineService') }}</p>
			</div>
		</div>
		<div class="money">
			<div>
				<p>{{ $t('user.availableBalance') }}</p>
				<p>{{ $t('utils.moneyMark') }}{{ data.money }}</p>
			</div>
			<div>
				<span @click="$router.push('/invest')">{{ $t('user.recharge') }}</span>
				<span @click="$router.push('/cash')">{{ $t('user.withdraw') }}</span>
			</div>
		</div>
		<div class="list">
			<van-cell is-link @click="$router.push('/moneybag')">
				<template #title>
					<span class="custom-title">{{ $t('user.myWallet') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/flashexchange')">
				<template #title>
					<span class="custom-title">{{ $t('user.shandui') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/ethRecharge')">
				<template #title>
					<span class="custom-title">{{ $t('user.ethrecharge') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/rechargeRecord')">
				<template #title>
					<span class="custom-title">{{ $t('user.rechargeRecord') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/withdrawRecord')">
				<template #title>
					<span class="custom-title">{{ $t('user.withdrawalRecord') }}</span>
				</template>
			</van-cell>
		</div>
		<div class="list">
			<van-cell is-link @click="$router.push('/myTeam')">
				<template #title>
					<span class="custom-title">{{ $t('index.invite') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/safe')">
				<template #title>
					<span class="custom-title">{{ $t('user.setting') }}</span>
				</template>
			</van-cell>
			<van-cell :title="$t('safe.signOut')" @click="logout" is-link />
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import qs from 'qs';
import Fetch from '../../utils/fetch';
import Api from "../../interface/index";
import {
	Icon,
	Cell,
	CellGroup
} from "vant";

Vue.use(Cell).use(CellGroup).use(Icon);

export default {
	name: "user",
	components: {
	},
	data() {
		return {
			data: {},
			eye: 1
		};
	},
	computed: {
		ethDisplay() {
			const n = Number(this.data.eth_money || 0);
			if (!n) return '0';
			return n.toFixed(4).replace(/\.?0+$/, '');
		}
	},
	created() {
		this.$parent.footer('user');
	},
	mounted() {
		this.start();
	},
	methods: {
		toKeFu() {
			Fetch('/index/webconfig', { type: 'web' }).then(res => {
				window.open(res.data.kefu_link)
			})
			return
		},
		start() {
			Fetch('/user/info').then((r) => {
				this.data = r.data;
			});
		}, logout() {
			localStorage.removeItem('token');
			this.$router.replace("/");
		}
	}
};
</script>

<style lang="less" scoped>
.user_wrap {
	background-color: #FAFAFA;
	max-width: 100%;
	overflow: hidden;
}

.top_header {
	position: relative;
	width: 100%;
	height: 277px;
	background: #000;
	background-size: 100% 100%;

	.set_go {
		width: 38px;
		height: 38px;
		position: absolute;
		top: 11px;
	}

	.set_go {
		right: 14px;
		background: url(../images/user/sign.png) no-repeat center center;
		background-size: 100% 100%;
	}

	.user_detail {
		width: 100%;
		padding: 28px 15px 0 15px;
		top: 34px;
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.user_header {
			width: 40px;
			height: 40px;
			overflow: hidden;
			border-radius: 50%;
			border: 3px solid rgba(255, 255, 255, 0.3);

			img {
				width: 100%;
				height: 100%;
			}
		}

		.user_name {
			margin-left: 3px;
			margin-top: 3px;
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			color: #FFFFFF;

			.user_all {
				display: flex;
				justify-content: flex-start;
				align-items: center;

				.user_nickname {
					line-height: 21px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}
	}

	.user_vip {
		color: #FFFFFF;
		font-weight: bold;
		font-size: 16px;
		margin: 10px 20px 20px 20px;
	}

	.user_balance {
		text-align: center;

		div {
			margin: 10px 0;
		}

		div:nth-child(1) {
			font-size: 14px;
			color: #d3d5d6;
		}

		div:nth-child(2) {
			font-weight: bold;
			font-size: 18px;
			color: #FFFFFF;
		}

.eth_inline {
	font-weight: bold;
	font-size: 18px;
	color: #FFFFFF;
	margin-left: 8px;
}
	}

	.user_money {
		display: flex;
		justify-content: space-between;
		text-align: center;

		p {
			margin: 10px 0;
		}

		div {
			width: 33.33%;
		}

		p:nth-child(1) {
			font-size: 14px;
			color: #d3d5d6;
		}

		p:nth-child(2) {
			font-size: 14px;
			color: #FFFFFF;
		}
	}
}

.kong {
	width: 100%;
	height: 35px;
	background: #FFFFFF;
}

.user_yw {
	display: flex;
	justify-content: space-between;
	text-align: center;
	width: 96%;
	position: relative;
	top: -83px;
	background: #FFFFFF;
	left: 2%;
	border-radius: 5px 5px 0 0;
	padding: 15px 0;

	div {
		width: 33.33%;
	}

	p {
		margin-top: 8px;
	}

	img {
		width: 30px;
		height: 30px;
	}
}

.money {
	display: flex;
	justify-content: space-between;
	width: 96%;
	background: #FFFFFF;
	border-radius: 5px;
	margin-top: -73px;
	margin-left: 2%;
	padding: 15px;

	div:nth-child(1) {
		width: 40%;
		text-align: left;

		p:nth-child(1) {
			color: #999;
			margin-bottom: 10px;
		}

		p:nth-child(2) {
			font-size: 14px;
			font-weight: bold;
		}
	}

	div:nth-child(2) {
		width: 60%;
		text-align: right;
		margin-top: 12px;

		span {
			padding: 5px 10px;
			border-radius: 5px;
			margin: 0 5px;
			color: #fff;
		}

		span:nth-child(1) {
			background: #000;
		}

		span:nth-child(2) {
			background: #5b5a58;
		}
	}
}

.list {
	width: 96%;
	margin-left: 2%;
	margin-top: 10px;
	border-radius: 5px;

	img {
		vertical-align: middle;
		height: 30px;
		width: 30px;
		margin-right: 10px;
	}
}
</style>